export default (key, description, scopes) => ({ key, description, scopes });
